import { render, staticRenderFns } from "./MovieInfoAdd.vue?vue&type=template&id=26cbf364&scoped=true&"
import script from "./MovieInfoAdd.vue?vue&type=script&lang=js&"
export * from "./MovieInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./MovieInfoAdd.vue?vue&type=style&index=0&id=26cbf364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cbf364",
  null
  
)

export default component.exports